export default "__VITE_ASSET__CAYPFt1z__"